import {createArticleBlockElement, createArticleBlockCaptionElement} from "@main/components/article";

export class Image {
    constructor(img) {
        this.img = img;
        this.img.className = "article-picture";

        this.buildImageArticleBlock();
    }

    buildImageArticleBlock = () => {
        this.articleBlock = createArticleBlockElement();

        this.img.parentNode.insertBefore(this.articleBlock, this.img);
        this.articleBlock.appendChild(this.img);
        
        if (this.img.getAttribute("title")) {
            this.articleBlock.appendChild(createArticleBlockCaptionElement(this.img.getAttribute("title")));
        }
    };
}
